import { render, staticRenderFns } from "./wpsa.vue?vue&type=template&id=9e15449c&scoped=true&"
import script from "./wpsa.vue?vue&type=script&lang=js&"
export * from "./wpsa.vue?vue&type=script&lang=js&"
import style0 from "./wpsa.vue?vue&type=style&index=0&id=9e15449c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e15449c",
  null
  
)

export default component.exports